import { ReactComponent as IconMenu } from "@/assets/svgs/on-boarding-action-icon.svg";
import { useEffect, useRef, useState } from "react";
import { usePopper } from "react-popper";
import MenuItems from "./MenuItems";
import ClickMultiCheck from '@/utils/click-multicheck';
import PropTypes from 'prop-types';

export default function MultiLevelDropDown({
	menuList,
	placement = "bottom-end",
	modifiers = [
		{
			name: "offset",
			options: { offset: [0, 2] },
		},
	],
	closeAll: closeAllParent = undefined,
	hasNotifyDot = false,
	id = undefined,
}) {
	const [visible, setVisible] = useState(false);
	const [closeAll, setCloseAll] = useState(true);

    useEffect(() => {
        const clickMultiCheckCb = (e) => ClickMultiCheck(popperRef, setVisible, e);
        document.addEventListener('mousedown', clickMultiCheckCb);
        return () => {
            document.removeEventListener('mousedown', clickMultiCheckCb);
        };
    }, []);

	const referenceRef = useRef(null);
	const popperRef = useRef(null);

	const { styles, attributes } = usePopper(
		referenceRef.current,
		popperRef.current,
		{
			placement,
			modifiers,
		}
	);

	const containerStyle = {
		...styles.popper,
		display: visible && !closeAll ? "flex" : "none",
		zIndex: 1,
	};

	useEffect(() => {
		if (closeAllParent) {
			setCloseAll(true);
		}
	}, [closeAllParent]);

	function handleDropdownClick(e) {
		e.preventDefault();
		e.stopPropagation();
		setVisible(true);
		setCloseAll(false);
	}

	return (
		<>
			<span
				ref={referenceRef}
				onClick={handleDropdownClick}
				data-testid="menu-btn"
				role="none"
				className="on-boarding__menu-btn"
				id={id}
			>
				<IconMenu id={id} />
				{hasNotifyDot && <div className="on-boarding__menu-btn__red-dot"></div>}
			</span>
			<div ref={popperRef} style={containerStyle} {...attributes.popper}>
				<div className="on-boarding__menu-dropdown__card">
					{menuList
						?.filter((item) => item !== undefined)
						?.map((item) => (
							<MenuItems
								item={item}
								hide={() => setCloseAll(true)}
								id={id}
							/>
						))}
				</div>
			</div>
		</>
	);
}

MultiLevelDropDown.propTypes = {
	menuList: PropTypes.arrayOf(PropTypes.object).isRequired,
	placement: PropTypes.string,
	modifiers: PropTypes.arrayOf(PropTypes.object),
	closeAll: PropTypes.bool,
	setCloseAll: PropTypes.func,
	hasNotifyDot: PropTypes.bool,
	id: PropTypes.string,
};
